export default "/images/arrow-down.svg?1eca03ef4a23db15831de9ee21016747";